export default "__VITE_ASSET__D0dr3xRa__"